import { useNavigate } from "react-router-dom";
import { AuthEndpoint } from "../../api";

const MyAccountSidebar = ({ activePane, setActivePane }) => {
    const menuItems = [
        { key: "dashboard", label: "Dashboard", icon: "fas fa-home" },
        { key: "myaccount", label: "Account Details", icon: "fas fa-user" },
        { key: "addproperty", label: "Add Property", icon: "fa-solid fa-map-location-dot" },
        { key: "myproperty", label: "My Properties", icon: "fa-solid fa-list" },
        { key: "rentproperty", label: "Rent Properties", icon: "fa-solid fa-heart" },
        { key: "managedproperty", label: "Managed Properties", icon: "fa-solid fa-heart" },
    ];

    const navigate = useNavigate();
    const authEndpoint = new AuthEndpoint();

    const handleLogout = async () => {
        try {
            await authEndpoint.logout();

            navigate("/login");
        } catch (error) {
            console.error("Logout failed:", error);
        }
    };
    return (
        <div className="ltn__tab-menu-list mb-50">
            <div className="nav">
                {menuItems.map((item) => (
                    <a
                        key={item.key}
                        onClick={() => setActivePane(item.key)}
                        className={activePane === item.key ? "active show" : ""}
                        style={{ cursor: "pointer" }}
                    >
                        {item.label} <i className={item.icon} />
                    </a>
                ))}

                <a onClick={handleLogout} style={{ cursor: "pointer" }}>
                    Logout <i className="fas fa-sign-out-alt" />
                </a>
            </div>
        </div>
    );
};

export default MyAccountSidebar;
